import * as Sentry from '@sentry/browser';
import Config from '../config';

const noop = () => null;

let init: (options: Sentry.BrowserOptions) => void = noop;
// Sentry v7 removed the `Severity` enum in favour of the SeverityLevel string union.
let captureMessage: (message: string, level?: Sentry.SeverityLevel) => string = noop;
let captureException: (exception: any) => string = noop;

if (!Config.DEBUG && Config.SENTRY_URL) {
  init = Sentry.init;
  captureMessage = Sentry.captureMessage;
  captureException = Sentry.captureException;
}

export default {
  init,
  captureMessage,
  captureException,
};
